import { useMemo } from "react";
import { Badge } from "@mantine/core";
import { CommunicationRoutingDecision } from "../../../services/admin/communicationLog.service";

const ROUTING_PRESENTATION: Record<
  CommunicationRoutingDecision,
  { color: string; label: string }
> = {
  redirected: { color: "orange", label: "Redirected" },
  bypassed: { color: "green", label: "Live — prefix bypass" },
  direct: { color: "blue", label: "Direct" },
  blocked: { color: "red", label: "Blocked" },
  unknown: { color: "gray", label: "Unknown" },
};

interface CommunicationRoutingBadgeProps {
  decision: CommunicationRoutingDecision | null;
}

export default function CommunicationRoutingBadge({
  decision,
}: CommunicationRoutingBadgeProps) {
  const presentation = useMemo(
    () =>
      decision
        ? ROUTING_PRESENTATION[decision]
        : { color: "gray", label: "Not applicable" },
    [decision]
  );

  if (!decision) {
    return (
      <Badge color={presentation.color} variant="light" size="sm">
        {presentation.label}
      </Badge>
    );
  }

  return (
    <Badge color={presentation.color} variant="light" size="sm">
      {presentation.label}
    </Badge>
  );
}
